function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "gray",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00B1A3",
  d: "M6.902 2.609h2.196c.384 0 .695-.312.695-.696 0-.384-.311-.696-.695-.696H6.902c-.384 0-.695.312-.695.696 0 .384.311.696.695.696zm-5.51 10.434h13.217v-6.26H1.39v6.26zM16 1.977V13.74c0 .384-.311.696-.696.696H.696c-.385 0-.696-.312-.696-.696V1.977c0-.384.311-.76.696-.76h1.626c.384 0 .695.312.695.696 0 .384-.311.696-.695.696h-.93v2.956h13.217V2.61h-.93c-.385 0-.696-.312-.696-.696 0-.384.311-.696.695-.696h1.626c.385 0 .696.376.696.76zm-4.696 1.99c.48 0 .87-.39.87-.87V.87c0-.48-.39-.87-.87-.87s-.87.39-.87.87v2.227c0 .48.39.87.87.87zm-7.478-.87V.87c0-.48.39-.87.87-.87s.87.39.87.87v2.227c0 .48-.39.87-.87.87s-.87-.39-.87-.87z",
  transform: "translate(1 2)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#00B1A3",
  d: "M.175 2.273h1.906c.097 0 .175-.079.175-.176V.177C2.256.079 2.178 0 2.081 0H.175C.078 0 0 .08 0 .177v1.92c0 .097.078.176.175.176zM3.242 2.273h1.906c.097 0 .175-.079.175-.176V.177C5.323.079 5.245 0 5.148 0H3.242c-.097 0-.175.08-.175.177v1.92c0 .097.078.176.175.176zM6.31 2.273h1.905c.097 0 .175-.079.175-.176V.177C8.39.079 8.312 0 8.215 0H6.309c-.097 0-.175.08-.175.177v1.92c0 .097.078.176.175.176z",
  transform: "translate(1 2) translate(4 9)"
})));

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.94d4b129.svg";
export { ForwardRef as ReactComponent };